// extracted by mini-css-extract-plugin
export default {"footer":"ChangePassword_footer__qQQrL"};